import GoogleAuth from "../pages/login/GoogleAuth";
import { AppStore } from "../stores/AppStore";

export const restoreAuthentication = async (api, setLoading) => {

    try {
        let userEmail = localStorage.getItem("userEmail")

        if (!userEmail) {
            return <GoogleAuth />
        }

        const authResponse = await api.get(`/auth/restore?email=${userEmail}`);

        if (authResponse.status === 200) {
            const { token, user } = authResponse.data;

            AppStore.update((s) => {
                s.googleToken = token;
                s.user = user;
            });

            if (!AppStore.currentState.slackUserData) {
                const slackAuth = await api.get(`/slack/${user.id}`);
                if (slackAuth?.data?.length) {
                    AppStore.update((s) => { s.slackUserData = slackAuth.data; });
                }
            }
        }
    } catch (error) {
        console.error('Error restoring authentication:', error);
    } finally {
        setLoading(false);
    }
};